import { render, staticRenderFns } from "./MisPedidos.vue?vue&type=template&id=2eb09d08&scoped=true&"
import script from "./MisPedidos.vue?vue&type=script&lang=js&"
export * from "./MisPedidos.vue?vue&type=script&lang=js&"
import style0 from "./MisPedidos.vue?vue&type=style&index=0&id=2eb09d08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb09d08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VAlert,VBtn,VChip,VContainer,VIcon,VProgressLinear,VSnackbar})
